import { defineStore } from "pinia";

export const UIStore = defineStore("UIStore", {
  state: () => ({
    currentWidth: window.innerWidth, 
    currentHeight: window.innerHeight, 
    isMobile: false
  }),
  actions: {
    setUiSize(currentWidth: number, currentHeight: number, isMobile: boolean) {
      this.currentWidth = currentWidth;
      this.currentHeight = currentHeight;
      this.isMobile = isMobile;
    },
  },
  getters: {
    getCurrentWidth(): number {
      return this.currentWidth;
    },
    showMobileLayout(): boolean{
      return this.isMobile || this.currentWidth < 1080;
    }
  }
});
